import React, { useState } from "react"
import {motion} from 'framer-motion'
import { useFormik } from "formik"
import * as Yup from 'yup'
import FieldInput from "../../Components/FieldInput"
import API from "../../Common/API"
import Button from "../../Components/Button"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"

const initialPassword = {
    mobileNumber :'',
    confirmPassword:'',
    password : ''
}

const ChangePassword = ()=>{


    const [userDetails,setUserDetails] = useState()
    const dispatch =  useDispatch()

    const passwordSchema = Yup.object().shape({
        mobileNumber : Yup.string().required("Mobile number is required"),
        confirmPassword : Yup.string().required("Confirm Password is required"),
        password : Yup.string().required("Password is required")
    })

    const passwordForm = useFormik({
        initialValues:initialPassword,
        validateOnMount:true,
        validationSchema:passwordSchema,
        enableReinitialize : true,
        onSubmit:(values)=>{
            values.userId = userDetails._id
            if(values.password === values.confirmPassword){
                API.post(`/auth/changePasswordForUser`,values).then((changeRes)=>{
                    if(changeRes.status === 200){
                        dispatch(setAlert({title:'Success',subtitle:'Password changed successfully',type:'success',active:true}))
                        setUserDetails({})
                        passwordForm.resetForm()
                    }
                })
            }else{
                dispatch(setAlert({title:'Error',subtitle:"Password and confirm password should be same",type:'error',active:true}))
            }
        }
    })

    const getUserDetails = ()=>{
        API.get(`/user/getUserDetailsByMobile/${passwordForm.values.mobileNumber}`).then((apiRes)=>{
                if(apiRes.status === 200){
                    setUserDetails(apiRes.data.data)
                }
            }).catch((err)=>{
                dispatch(setAlert({title:'Error',subtitle:'Account not found',type:'error',active:true}))
            })
    }


    return (
        <motion.div className="h-full w-full relative grid grid-cols-1 gap-5 px-5 ">
            <p className="text-md font-bold">Change password</p>
            <motion.div className="flex flex-row items-center">
                <FieldInput label={'Mobile number'} type="phone" fieldProps={passwordForm.getFieldProps('mobileNumber')} fieldMeta={passwordForm.getFieldMeta('mobileNumber')} fieldHelper={passwordForm.getFieldHelpers('mobileNumber')} edit={true} dataLoaded={true}/>
                <Button type={'primary'} onClick={()=>getUserDetails()}>Search User</Button>
            </motion.div>
            {
                userDetails && <motion.div className="w-96 px-10 my-5 grid grid-cols-2 gap-1 sm:grid-cols-1 md:grid-cols-2">
                    <motion.div>
                        <p>Name</p>
                        <p>{userDetails.firstName}</p>
                        </motion.div>
                        <motion.div>
                        <p>RefId</p>
                        <p>{userDetails.refId}</p>
                        </motion.div>
                    </motion.div>
            }
            <motion.div className="w-96 grid grid-cols-1">
                <FieldInput label={'Password'} type="password" fieldProps={passwordForm.getFieldProps('password')} fieldMeta={passwordForm.getFieldMeta('password')} fieldHelper={passwordForm.getFieldHelpers('password')} edit={true} dataLoaded={true}/>
                <FieldInput label={'Confirm Password'} type="password" fieldProps={passwordForm.getFieldProps('confirmPassword')} fieldMeta={passwordForm.getFieldMeta('confirmPassword')} fieldHelper={passwordForm.getFieldHelpers('confirmPassword')} edit={true} dataLoaded={true}/>
                <Button  type={'primary'} onClick={()=>passwordForm.submitForm()}>Submit</Button>
            </motion.div>
        </motion.div>
    )   
}

export default ChangePassword